export default __webpack_public_path__ + "static/media/background-3.919687d0.jpg";